import { BUILD_VERSION } from '../../buildVersion'

const version = process.env['REACT_APP_VERSION'] || BUILD_VERSION || '0.0.0'

export const DisplayAppVersion = () => {
  return (
    <div style={{color: '#262626', fontSize: '12px'}}>
      v{version}
    </div>
  );
};
